import axios from 'ggApp/utils/requests';
import shortid from 'shortid';
import slug from 'slugg';

import { serverValidation } from 'ggApp/modules/form/validations';
import { transitionTo } from 'ggApp/modules/router/actions';
import ggNotification from 'ggApp/modules/notification';
import * as at from '../actionTypes';

export function getSubscriptions() {
    return (dispatch) => {
        dispatch({ type: at.GET_SUBSCRIPTIONS });
        return axios
            .get('/subscriptions')
            .then((result) => {
                dispatch({
                    type: at.GET_SUBSCRIPTIONS_SUCCESS,
                    data: result.data.subscriptions,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: at.GET_SUBSCRIPTIONS_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}

export function getSubscription(subscriptionId) {
    return (dispatch) => {
        dispatch({ type: at.GET_SUBSCRIPTION });
        return axios
            .get(`/subscriptions/${subscriptionId}`)
            .then((result) => {
                dispatch({
                    type: at.GET_SUBSCRIPTION_SUCCESS,
                    data: result.data.subscription,
                });
            })
            .catch(({ response: error = {} }) => {
                if (error.data) {
                    dispatch({
                        type: at.GET_SUBSCRIPTION_ERROR,
                        error: error.data,
                    });
                }
            });
    };
}

export function getSubscriptionRentalPlans(subscriptionId) {
    return (dispatch) => {
        dispatch({ type: at.GET_SUBSCRIPTION_RENTAL_PLAN });
        return axios
            .get(`/subscriptions/${subscriptionId}/rental_plans`)
            .then((result) => {
                dispatch({
                    type: at.GET_SUBSCRIPTION_RENTAL_PLAN_SUCCESS,
                    data: result.data.rental_plans,
                });

                return result;
            })
            .catch(({ response: error = {} }) => {
                if (error.data || error.statusText) {
                    dispatch({
                        type: at.GET_SUBSCRIPTION_RENTAL_PLAN_ERROR,
                        error: error.data || {
                            message: error.statusText,
                        },
                    });
                } else {
                    throw error;
                }
            });
    };
}

export function updateSubscriptionPaymentMethod(subscriptionSfId, payment = {}, options = {}) {
    return (dispatch) => {
        dispatch({ type: at.UPDATE_SUBSCRIPTION_PAYMENT_METHOD });
        return axios
            .patch('/payment_methods/change', {
                subscription_id: subscriptionSfId,
                payment_method_type: payment.type,
                payment_method_id: payment.id,
            })
            .then((result) => {
                const newSubscription = result.data.subscription || {};
                const lowerSlug = slug(newSubscription.status);
                const defaultPath = `/dashboard/subscriptions/${lowerSlug}/${newSubscription.subscription_number}`;
                const { redirectPath } = options;
                const hasRedirectPath = !!redirectPath;
                const path = hasRedirectPath ? redirectPath : defaultPath;

                dispatch({
                    type: at.UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS,
                    data: newSubscription,
                });

                dispatch(transitionTo(path));
                dispatch(
                    ggNotification.actions.addNotification({
                        id: shortid.generate(),
                        message: 'NOTIFICATION_PAYMENT_METHOD_CHANGED',
                        level: 'success',
                    }),
                );
            })
            .catch((error) => {
                const { response } = error || {};
                if (response && response.data) {
                    dispatch({
                        type: at.UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR,
                        error: response.data,
                    });
                } else {
                    throw error;
                }
            });
    };
}

export function purchase(subscriptionSfId, password) {
    return (dispatch) => {
        dispatch({ type: at.PURCHASE_SUBSCRIPTION });
        return axios
            .post(`/subscriptions/${subscriptionSfId}/purchase`, {
                password,
            })
            .then((result) => {
                dispatch({
                    type: at.PURCHASE_SUBSCRIPTION_SUCCESS,
                    data: result.data.subscription,
                });

                return result;
            })
            .catch((error) => {
                if (error.response && error.response.data) {
                    dispatch({
                        type: at.PURCHASE_SUBSCRIPTION_ERROR,
                        error: error.response.data,
                    });
                    serverValidation(error);
                }
            });
    };
}

export function updateSubscription(subscription) {
    return {
        type: at.UPDATE_SUBSCRIPTION_DATA,
        data: subscription,
    };
}

export function getSubscriptionActions(subscriptionId) {
    return (dispatch) => {
        dispatch({
            type: at.GET_SUBSCRIPTION_ACTIONS,
        });

        return axios
            .get(`/subscriptions/${subscriptionId}/actions`)
            .then((response) => {
                const { actions } = response.data || {};

                dispatch({
                    type: at.GET_SUBSCRIPTION_ACTIONS_SUCCESS,
                    actions,
                });
            })
            .catch(({ response: error }) => {
                if (!error.data && !error.statusText) {
                    throw error;
                }

                const errorData = error.data ? error.data : { message: error.statusText };

                dispatch({
                    type: at.GET_SUBSCRIPTION_ACTIONS_ERROR,
                    error: errorData,
                });
            });
    };
}

export function getReturnLabel(subscriptionSfId) {
    return (dispatch) => {
        dispatch({ type: at.GET_SUBSCRIPTION_RETURN_LABEL });
        return axios
            .get(`/subscriptions/${subscriptionSfId}/return_label`)
            .then((result) => {
                const newResult = {
                    sf_id: subscriptionSfId,
                    ...result.data,
                };
                dispatch({
                    type: at.GET_SUBSCRIPTION_RETURN_LABEL_SUCCESS,
                    data: newResult,
                });

                return newResult;
            })
            .catch(({ response: error }) => {
                if (!error.data && !error.statusText && !error.status) {
                    throw error;
                }

                const errorData = error.data ?? { status: error.status, message: error.statusText };

                throw errorData;
            });
    };
}

export function resetReturnLabel() {
    return (dispatch) => {
        dispatch({
            type: at.RESET_SUBSCRIPTION_RETURN_LABEL_SUCCESS,
        });
    };
}

export function setCurrentSubscriptionId(subscriptionId) {
    return {
        type: at.SET_CURRENT_SUBSCRIPTION_ID,
        subscriptionId,
    };
}

export function removeCurrentSubscriptionId() {
    return {
        type: at.REMOVE_CURRENT_SUBSCRIPTION_ID,
    };
}
